import { render, staticRenderFns } from "./ManoeuvreRating.vue?vue&type=template&id=72681fdc"
import script from "./ManoeuvreRating.vue?vue&type=script&lang=js"
export * from "./ManoeuvreRating.vue?vue&type=script&lang=js"
import style0 from "./ManoeuvreRating.vue?vue&type=style&index=0&id=72681fdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports